// extracted by mini-css-extract-plugin
module.exports = {"tagsPage":"tags-module--tagsPage--1Q4Fv","pageTitle":"tags-module--pageTitle--1UnPz","tagsPanel":"tags-module--tagsPanel--2Hm-t","item":"tags-module--item--2ZqMt"};